import { useEffect } from 'react';
import { AppProvider, useAppContext } from '@/context/AppContext';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { FileManager } from '@/components/FileManager';
import { Toolbar } from '@/components/Toolbar';
import { Content } from '@/components/Content';
import { MessageDisplay } from '@/components/MessageDisplay';
import { HistoryFeed } from '@/components/HistoryFeed';
import './App.css';
import './styles/index.css';

function AppContent() {
    const { state } = useAppContext();

    useEffect(() => {
        // Set up global error handlers
        const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
            console.error('Unhandled promise rejection:', event.reason);
            // Prevent the default browser behavior
            event.preventDefault();
        };

        const handleError = (event: ErrorEvent) => {
            console.error('Global error:', event.error);
        };

        // Add event listeners
        window.addEventListener('unhandledrejection', handleUnhandledRejection);
        window.addEventListener('error', handleError);

        // Cleanup
        return () => {
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
            window.removeEventListener('error', handleError);
        };
    }, []);

    // Warn about unsaved changes before page unload
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (state.hasUnsavedChanges) {
                e.preventDefault();
                return (e.returnValue = '');
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [state.hasUnsavedChanges]);

    return (
        <div className="app">
            <div className="container">
                <header className="app-header">
                    <img src="/tekst_1825x632.png" alt="Sequel PopGroups Editor" className="header-logo" />
                    <h1>Sequel PopGroups Editor</h1>
                    <p>
                        This application allows users to edit XML files containing `pedGroups` and `vehGroups`.
                    </p>
                </header>

                <MessageDisplay />

                <main className="app-main">
                    <FileManager />
                    {state.xmlDoc && <Toolbar />}
                    <Content />
                    <HistoryFeed />
                </main>

            </div>
        </div>
    );
}

function App() {
    return (
        <ErrorBoundary>
            <AppProvider>
                <AppContent />
            </AppProvider>
        </ErrorBoundary>
    );
}

export default App;
